import React from 'react';
import { Outlet } from 'react-router-dom';
import KartenverwaltungHeader from '../components/dashboard/kartenverwaltung/KartenverwaltungHeader';
import CardList from '../components/dashboard/kartenverwaltung/CardList';
import { KartenverwaltungDetail } from '../components';

const Kartenverwaltung = () => {
  return (
    <>
      <KartenverwaltungHeader />
      <CardList />
      <KartenverwaltungDetail />
    </>
  );
};

export default Kartenverwaltung;
